import React from 'react';
import { useParams } from 'react-router-dom';
import Encabezado from '../components/Encabezado';
import { Table, Badge } from 'react-bootstrap';
import dataCarreras from '../data/carreras.json';
import { obtenerEstadoCarrera, formatearFecha } from '../utils/estadoCarrera';

const CarreraDetalle = () => {
    const { slug } = useParams();
    const carrera = dataCarreras.find((item) => item.slug === slug);

    if (!carrera) {
        return (
            <div>
                <Encabezado titulo="Carrera no encontrada" />
                <p className="text-center">La carrera solicitada no existe o fue dada de baja.</p>
            </div>
        );
    }

    const estado = obtenerEstadoCarrera(carrera);
    const grupos = [...new Set((carrera.planEstudios || []).map((item) => item.anio))];

    return (
        <div>
            <Encabezado titulo={`${carrera.nombre} - Sede ${carrera.sede}`} />

            <div className="text-center mb-3">
                <Badge
                    style={{
                        backgroundColor: estado.bg,
                        color: estado.color,
                        fontSize: '0.95rem',
                        padding: '8px 14px',
                    }}
                >
                    {estado.texto}
                </Badge>
                {carrera.abreInscripcion && carrera.fechaAperturaInscripcion && (
                    <p className="text-muted mt-2 mb-0">
                        Apertura de inscripción: {formatearFecha(carrera.fechaAperturaInscripcion)}
                    </p>
                )}
            </div>

            <h4 className="text-center">Plan de Estudios: {carrera.descripcion}</h4>

            {grupos.length > 0 ? (
                <Table striped bordered size="sm">
                    <thead>
                        <tr>
                            <th>Código</th>
                            <th>Correlativa</th>
                            <th>Materia</th>
                            <th>H.C.</th>
                        </tr>
                    </thead>
                    <tbody>
                        {grupos.map((anio) => (
                            <React.Fragment key={anio}>
                                <tr>
                                    <td colSpan="4" className="text-center h6">- {anio} -</td>
                                </tr>
                                {carrera.planEstudios
                                    .filter((item) => item.anio === anio)
                                    .map((item) => (
                                        <tr key={`${anio}-${item.codigo}`}>
                                            <td>{item.codigo}</td>
                                            <td>{item.correlativa}</td>
                                            <td>{item.materia}</td>
                                            <td>{item.horas}</td>
                                        </tr>
                                    ))}
                            </React.Fragment>
                        ))}
                    </tbody>
                </Table>
            ) : (
                <p className="text-center text-muted">
                    El plan de estudios de esta carrera todavía no fue cargado.
                </p>
            )}

            {carrera.cargaHoraria && <h5>Total Carga Horaria: {carrera.cargaHoraria}</h5>}
        </div>
    );
};

export default CarreraDetalle;